var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"StaffManage-list"},[_c('GlobalInfoBar',{attrs:{"title":"人工审单","content":"将配置好的订单，进行人工审核"}}),_c('GlobalChunk',{attrs:{"icon":"search","title":"筛选查询"}},[_c('div',{attrs:{"slot":"filter"},slot:"filter"},[_c('myFrom')],1),_c('myTable')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }